import React, { useRef, useState } from 'react';
import cn from 'classnames';
import styles from "./TableList.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TableListStructure(_ref) {
  let {
    header,
    content,
    onScroll,
    className
  } = _ref;
  const [contentEl, setContentEl] = useState(null);
  const [hasHorizontalScroll, setHasHorizontalScroll] = useState(false);
  const resizeObsRef = useRef();
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.container, className),
    onScroll: onScroll,
    children: [header, /*#__PURE__*/_jsx("div", {
      className: cn(styles.containerContent, hasHorizontalScroll && styles.hasHorizontalScroll),
      ref: el => {
        if (el) {
          // Use ResizeObserver to detect changes in element size and render tooltip accordingly.
          if (!resizeObsRef.current) {
            resizeObsRef.current = new ResizeObserver(entries => {
              requestAnimationFrame(() => {
                if (!Array.isArray(entries) || !entries.length) return;
                for (const entry of entries) {
                  entry.target && setHasHorizontalScroll(entry.target.clientWidth < entry.target.scrollWidth);
                }
              });
            });
          }
          resizeObsRef.current.observe(el);
        } else if (resizeObsRef.current && contentEl) {
          resizeObsRef.current.unobserve(contentEl);
        }
        setContentEl(el);
      },
      children: content
    })]
  });
}